import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteAhjFeeScheduleVariableMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type DeleteAhjFeeScheduleVariableMutation = { __typename?: 'mutation_root', delete_ahj_fee_schedule_variables_by_pk?: { __typename?: 'ahj_fee_schedule_variables', id: any } | null };


export const DeleteAhjFeeScheduleVariableDocument = gql`
    mutation deleteAhjFeeScheduleVariable($id: uuid!) {
  delete_ahj_fee_schedule_variables_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAhjFeeScheduleVariableMutationFn = Apollo.MutationFunction<DeleteAhjFeeScheduleVariableMutation, DeleteAhjFeeScheduleVariableMutationVariables>;

/**
 * __useDeleteAhjFeeScheduleVariableMutation__
 *
 * To run a mutation, you first call `useDeleteAhjFeeScheduleVariableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAhjFeeScheduleVariableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAhjFeeScheduleVariableMutation, { data, loading, error }] = useDeleteAhjFeeScheduleVariableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAhjFeeScheduleVariableMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAhjFeeScheduleVariableMutation, DeleteAhjFeeScheduleVariableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAhjFeeScheduleVariableMutation, DeleteAhjFeeScheduleVariableMutationVariables>(DeleteAhjFeeScheduleVariableDocument, options);
      }
export type DeleteAhjFeeScheduleVariableMutationHookResult = ReturnType<typeof useDeleteAhjFeeScheduleVariableMutation>;
export type DeleteAhjFeeScheduleVariableMutationResult = Apollo.MutationResult<DeleteAhjFeeScheduleVariableMutation>;
export type DeleteAhjFeeScheduleVariableMutationOptions = Apollo.BaseMutationOptions<DeleteAhjFeeScheduleVariableMutation, DeleteAhjFeeScheduleVariableMutationVariables>;